import api from 'src/utils/api/core'

export function getPorts() {
  return api.get('/ports')
}
